import { getWarehouses } from "@insite/client-framework/Services/WarehouseService";
import { getGeoFallbackBranch } from "@WhiteCap/Services/GeoFallbackBranchService";

export const performGeolocationWarehouseSelection = async (): Promise<string | null> => {
    try {
        const position = await getCurrentPosition();
        const { latitude, longitude } = position.coords;

        const warehousesResult = await getWarehouses({
            search: "",
            latitude,
            longitude,
            page: 1,
            pageSize: 1,
        });

        if (warehousesResult.warehouses && warehousesResult.warehouses.length > 0) {
            return warehousesResult.warehouses[0].id;
        }

        return getFallbackWarehouse();
    } catch (error) {
        return getFallbackWarehouse();
    }
};

const getFallbackWarehouse = async (): Promise<string> => {
    try {
        const result = await getGeoFallbackBranch();
        if (result?.nearestBranch?.id) {
            return result.nearestBranch.id;
        }
    } catch (error) {
        // Fallback to default if API fails
    }

    // This should never be reached as backend always returns a warehouse,
    // but kept as a safety net
    throw new Error("No fallback warehouse available");
};

const getCurrentPosition = (): Promise<GeolocationPosition> => {
    return new Promise((resolve, reject) => {
        if (!navigator.geolocation) {
            reject(new Error("Geolocation not supported"));
            return;
        }

        navigator.geolocation.getCurrentPosition(resolve, reject, {
            timeout: 5000,
            maximumAge: 0,
        });
    });
};
